// Date/time formatting for the dashboard, driven by the active language. Delegates to
// the shared formatter in packages/i18n (DR-49) so Bangla never shows "AM"/"PM" or
// Latin digits — `toLocale*String('bn-BD')` keeps the English day period.
// A single named file (rule 7.1-2 bans utils/) imported explicitly where needed.
// All timestamps from the API are ISO-8601 UTC strings (contract Timestamp).
import {
  formatDate as formatDateI18n,
  formatTime as formatTimeI18n,
} from '@bookingdei/i18n/format-date';
import { formatMessage } from '@bookingdei/i18n/interpolate';

type Lang = 'en' | 'bn';

function parse(iso: string | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

// "9:25 AM" / "সকাল ৯:২৫".
export function formatTime(iso: string | undefined, lang: Lang): string {
  const d = parse(iso);
  return d ? formatTimeI18n(lang, d, { alwaysMinutes: true }) : '—';
}

// "7 Jul 2026" / "৭ জুলাই ২০২৬".
export function formatDate(iso: string | undefined, lang: Lang): string {
  const d = parse(iso);
  return d ? formatDateI18n(lang, d) : '—';
}

// "7 Jul, 2:30 PM" / "৭ জুলাই, দুপুর ২:৩০".
export function formatDateTime(iso: string | undefined, lang: Lang): string {
  const d = parse(iso);
  if (!d) return '—';
  return formatMessage(lang, 'format.date.with_time', {
    date: formatDateI18n(lang, d, { year: false }),
    time: formatTimeI18n(lang, d, { alwaysMinutes: true }),
  });
}
